import React from 'react';
import { Button } from './Button.jsx';

function FigmaIcon({ size = 14, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z" />
      <path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z" />
      <path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z" />
      <path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z" />
      <path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z" />
    </svg>
  );
}

/**
 * A component's design reference, from Storybook's `parameters.design`
 * (storybook-addon-designs: `{ type: 'figma', url }`, an array of those, or a
 * bare URL). The first link with a URL wins. Returns { url, label } or null.
 */
export function designLink(design) {
  const first = [design].flat().find((d) => (typeof d === 'string' ? d : d?.url));
  const url = typeof first === 'string' ? first : first?.url;
  if (!url || !/^https?:\/\//.test(url)) return null;
  const label = first?.name ?? (first?.type === 'figma' || /figma\.com\//.test(url) ? 'Figma' : 'Design');
  return { url, label };
}

/** The design link in the docs toolbar, and beside a story title on the canvas. */
export function DesignPill({ link, className = '' }) {
  if (!link) return null;
  return (
    <Button variant="ghost" size="compact" className={className} leadingIcon={FigmaIcon} title={`Open in ${link.label}`} render={<a href={link.url} target="_blank" rel="noreferrer" />}>
      {link.label}
    </Button>
  );
}
